import React from 'react';
import { Eye, LogOut } from 'lucide-react';

const ImpersonationBanner = () => {
    const impersonatorToken = localStorage.getItem('impersonatorToken');

    if (!impersonatorToken) return null;

    const handleExitPreview = () => {
        const adminToken = localStorage.getItem('impersonatorToken');
        if (adminToken) {
            localStorage.setItem('token', adminToken);
            localStorage.removeItem('impersonatorToken');
            window.location.href = '/users';
        }
    };

    return (
        <div className="bg-yellow-500 text-white px-6 py-2 flex justify-between items-center shadow-md animate-pulse fixed top-0 left-0 right-0 z-[100] h-10">
            <div className="flex items-center gap-3">
                <Eye size={20} />
                <span className="font-semibold text-sm md:text-base">You are currently in Preview Mode</span>
                <span className="text-xs opacity-90 hidden lg:inline ml-2">Seeing the application through this user's account</span>
            </div>
            <button
                onClick={handleExitPreview}
                className="flex items-center gap-2 bg-white text-yellow-600 px-3 py-1 rounded-full font-bold text-xs md:text-sm hover:bg-yellow-50 transition-colors shadow-sm whitespace-nowrap"
            >
                <LogOut size={14} />
                Exit Preview
            </button>
        </div>
    );
};

export default ImpersonationBanner;
